import { useEffect, useRef, useState } from 'react';
import { fetchCallFollowUps } from '../CallFollowUps/callFollowUpApi';
import runGuardedRequest from '../CallFollowUps/guardedRequest';

const useFollowUpList = ({ requestParams, requestKey }) => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [listError, setListError] = useState(null);
  const [loading, setLoading] = useState(false);
  const followUpsRequestIdRef = useRef(0);

  const loadFollowUps = () => {
    const requestId = followUpsRequestIdRef.current + 1;
    followUpsRequestIdRef.current = requestId;

    return runGuardedRequest({
      isCurrent: () => requestId === followUpsRequestIdRef.current,
      onStart: () => {
        setLoading(true);
        setListError(null);
      },
      request: () => fetchCallFollowUps(requestParams),
      onSuccess: (result) => {
        setData(result.call_followups);
        setTotalCount(result.meta.total_count || 0);
      },
      onError: () => {
        setListError('Unable to load follow-ups. Please refresh the tab and try again.');
      },
      onFinally: () => setLoading(false),
    });
  };

  useEffect(() => {
    loadFollowUps();

    return () => {
      followUpsRequestIdRef.current += 1;
    };
  }, [requestKey]);

  return {
    data,
    listError,
    loading,
    totalCount,
  };
};

export default useFollowUpList;
